<template>
  <div>
    <v-col offset-md="3" :md="6">
      <h1 class="primary--text text-center mt-5">User Profile</h1>
      <h3 class="primary--text text-center">e-mail: {{ userProfile.userEmail }}</h3>
      <v-text-field v-model="fName" ref="fName" label="First Name" @change="entryChange=true" />
      <v-text-field v-model="lName" ref="lName" label="Last Name" @change="entryChange=true" />
      <v-row>
        <v-btn color="error" outlined to="/">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="saveChange">Save Changes</v-btn>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'profile',
  computed: {
    ...mapGetters([
      'userProfile'
    ])
  },
  data: () => ({
    fName: '',
    lName: '',
    entryChange: false,
  }),
  created() {
    this.fName = this.userProfile.userFName,
    this.lName = this.userProfile.userLName
  },
  methods: {
    saveChange() {
      if (!this.entryChange) {
        return
      }
      var user = {
        userId: this.userProfile._id,
        userFName: this.fName,
        userLName: this.lName,
      }
      const token = this.$store.getters.authToken
      const header = { 'Content-type': 'application/json', 'x-auth': token }
      axios.post('/api/updateuser', JSON.stringify(user), { headers: header })
      .then (() => {
        this.$store.dispatch('authenticateToken')
      })
    }
  }
}
</script>